export const ANNOTATION_CLOSE = 'ANNOTATION:ANNOTATION_CLOSE';
export const ANNOTATION_RECORD_LIST_LOADED = 'ANNOTATION:RECORD_LIST_LOADED';
export const ANNOTATION_RECORD_LIST_LOAD_ERROR = 'ANNOTATION:RECORD_LIST_LOAD_ERROR';
export const ANNOTATION_INITED = 'ANNOTATION:INIT';
export const ANNOTATION_SET_LOADING = 'ANNOTATION:SET_LOADING';
export const ANNOTATION_CHANGE_TEXT = 'ANNOTATION:CHANGE_TEXT';
export const ANNOTATION_TEXT_SEARCH = 'ANNOTATION:TEXT_SEARCH';
export const ANNOTATION_ADD_LAYER_FROM_CATALOGS = 'ANNOTATION:ADD_LAYER_FROM_CATALOGS';

export const ACTION_POINT = {title: 'Ponto', type: 'Point', geometryType: 'Point'};
export const ACTION_LINE = {title: 'Linha', type: 'LineString', geometryType: 'LineString'};
export const ACTION_POLYGON = {title: 'Polígono', type: 'Polygon', geometryType: 'Polygon'};
export const ACTION_CIRCLE = {title: 'Círculo', type: 'Circle', geometryType: 'Circle'};
export const ACTION_TEXT = {title: 'Texto', type: 'Text', geometryType: 'Point'};

export const ANNOTATION_BASE_PROPERTY = 'type';
export const ANNOTATION_BASE_PROPERTY_VALUE = 'cityhub-annotations';

export const TEMPORARY_PROPERTY = '__temporary__';
export const IS_CIRCLE_PROPERTY = 'isCircle';
export const RADIUS_PROPERTY = 'radius';
export const CENTER_PROPERTY = 'center';
export const CIRCLE_POLYGON_GEOM_PROPERTY = 'polygonGeom';
export const GEOM_PROPERTY = '_geom';
